export default async (category, { goveoDefaultSubCategoryRepository }) => {
    return await goveoDefaultSubCategoryRepository.fetch(category);
}
